import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const SERVICES = [
  "Executive Search",
  "Retained Search",
  "Permanent Hiring",
  "Contract & Staff Augmentation",
  "HR Advisory",
  "Training",
];

export const Footer = () => (
  <footer className="bg-ink text-paper" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-20">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <p className="font-serif text-3xl tracking-tight">
            ALLY <span className="italic text-gold">eXecutive</span> HR
          </p>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-paper/60">
            Executive Search. Talent Strategy. Human Intelligence. Building
            leadership teams and high-impact talent organizations across India,
            Asia & EMEA.
          </p>
          <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.25em] text-gold">
            Powered by RoleSense™ — Contextual Recruitment Intelligence
          </p>
        </div>
        <div className="lg:col-span-3">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-paper/40">Services</p>
          <ul className="mt-5 space-y-2.5">
            {SERVICES.map((s) => (
              <li key={s}>
                <Link
                  to="/services"
                  className="text-sm text-paper/70 transition-colors hover:text-gold"
                  data-testid={`footer-service-${s.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                >
                  {s}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-2">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-paper/40">Firm</p>
          <ul className="mt-5 space-y-2.5">
            <li><Link to="/" className="text-sm text-paper/70 hover:text-gold" data-testid="footer-nav-home">Home</Link></li>
            <li><Link to="/rolesense" className="text-sm text-paper/70 hover:text-gold" data-testid="footer-nav-rolesense">RoleSense™</Link></li>
            <li><Link to="/about-contact" className="text-sm text-paper/70 hover:text-gold" data-testid="footer-nav-about">About</Link></li>
            <li><Link to="/about-contact#contact" className="text-sm text-paper/70 hover:text-gold" data-testid="footer-nav-contact">Contact</Link></li>
          </ul>
        </div>
        <div className="lg:col-span-2">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-paper/40">Start</p>
          <Link
            to="/about-contact#contact"
            className="group mt-5 inline-flex items-center gap-2 border border-gold px-5 py-3 text-sm font-semibold text-gold transition-colors duration-300 hover:bg-gold hover:text-ink"
            data-testid="footer-start-conversation-button"
          >
            Start a Conversation
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
          <div className="mt-6 space-y-1.5 text-sm text-paper/50">
            <p>s-kaul@ally-executive.com</p>
            <p>India +91 96543 83898 · UAE +971 58 145 1549</p>
            <p>Noida · Bangalore (India) · Ajman Free Zone (UAE)</p>
          </div>
        </div>
      </div>
      <div className="mt-14 flex flex-col gap-3 border-t border-paper/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-xs text-paper/40">© {new Date().getFullYear()} Ally eXecutive HR. All rights reserved.</p>
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-paper/40">
          India · Asia · EMEA
        </p>
      </div>
    </div>
  </footer>
);
